
































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import IImage from '@frontend/types/base/IImage';
import IImageSrcset from '@frontend/types/base/IImageSrcset';

@Component({
	componentId: 'C001'
})
export default class ImageComponent extends Vue {
	protected TRANSPARENT_PIXEL: string =
		'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'; // eslint-disable-line

	@Prop(Object)
	protected readonly image!: IImage;

	@Prop({ type: Boolean, default: false })
	protected readonly disableFocalPoint!: boolean;

	protected get srcString(): string | undefined {
		const { srcset } = this.image;

		// Simple source? (Like svg)
		if (!srcset || !srcset.length) {
			return this.image.src || this.TRANSPARENT_PIXEL;
		}

		return (srcset.length >= 2 ? srcset[1].src : srcset[0].src) || this.TRANSPARENT_PIXEL;
	}

	protected get srcsetString(): string | undefined {
		let str = '';

		if (!this.image.srcset) {
			return;
		}

		this.image.srcset.forEach((item: IImageSrcset, index: number): void => {
			str += `${item.src || this.TRANSPARENT_PIXEL} ${item.width}w`;

			if (index === 0 && item.height) {
				str += ` ${item.height}h`;
			}

			str += ',';
		});

		return str.slice(0, -1);
	}

	protected get inlineAspectRatio(): number {
		if (this.image.width && this.image.height) {
			return (this.image.height / this.image.width) * 100;
		}

		return 1.0;
	}

	protected get wrapperClasses(): string {
		return this.image.aspectRatio
			? `o-aspect-ratio o-aspect-ratio--${this.image.aspectRatio}`
			: 'c-image-component__image-wrapper';
	}

	protected get focalPointStyle(): any | null {
		if (!this.image.focalPoint || this.disableFocalPoint) {
			return null;
		}

		return {
			objectFit: 'cover',
			objectPosition: `${this.image.focalPoint.x * 100}% ${this.image.focalPoint.y * 100}%`
		};
	}

	/**
	 * Please note: noscript breaks vue hydration in prod mode
	 * @returns {boolean}
	 */
	protected get supportsNoScript(): boolean {
		return (!this.$options.hydration || this.$options.hydration === 'vanilla') && typeof window === 'undefined';
	}
}
